var React = require('react');

function Quality (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0, 0)"},React.createElement("path",{"d":"M31.144,11.643,21.3,10.212l-4.4-8.92a1.041,1.041,0,0,0-1.794,0l-4.4,8.92L.856,11.643A1,1,0,0,0,.3,13.348l7.124,6.944L5.744,30.1A1,1,0,0,0,7.195,31.15L16,26.521l8.805,4.629A1,1,0,0,0,26.256,30.1l-1.682-9.8L31.7,13.348a1,1,0,0,0-.555-1.705Z"})));
}

Quality.defaultProps = {"x":"0px","y":"0px","width":"32px","height":"32px","viewBox":"0 0 32 32"};

module.exports = Quality;

Quality.default = Quality;
